import { CsvImportReturnDto, ImportColumn } from '@/endpoints/models'

import { ImportStructureProps } from '../../hooks/useImport'

export type InputDataParsed = Papa.ParseResult<string[]>

export type CsvOnMapped = (
	data?: ImportColumn[],
	importStructureProps?: ImportStructureProps,
	csvMapped?: boolean,
) => void

/** Field name to csv column index map */
export type CsvMapping = {
	[fieldName: string]: number | undefined
}
export interface CsvImporterContextState {
	checkResult?: CsvImportReturnDto
	firstRow?: string[]
	formDataCheck?: ImportStructureProps
	hasHeaders: boolean
	inputDataParsed?: InputDataParsed
	/** Mapping between csv column & field */
	mapping: CsvMapping
	nodeId: number
	/** Callback for parent component after mapping */
	onMapped: CsvOnMapped
	/** Clear values set by onMapped callback  */
	resetImport: () => void
	/** Mapped data */
	rows?: ImportColumn[]
	step: CsvImporterStepEnum
}

export interface CsvImporterContextType {
	dispatch: React.Dispatch<Actions>
	state: CsvImporterContextState
}

export enum CsvImporterStepEnum {
	PREVIEW,
	COLUMNS,
	CHECK,
}

export enum ActionTypeEnum {
	STEP_SET,
	FORM_DATA_CHECK_SET,
	ROWS_SET,
	CHECK_RESULT_SET,
	INPUT_DATA_PARSED_SET,
	HAS_HEADERS_SET,
	CSV_MAPPING_UPDATE,
}

type ActionChangeStep = {
	step: CsvImporterStepEnum
	type: ActionTypeEnum.STEP_SET
}

type ActionFormDataCheckSet = {
	formDataCheck: ImportStructureProps
	type: ActionTypeEnum.FORM_DATA_CHECK_SET
}

type ActionRowsSet = {
	rows: ImportColumn[]
	type: ActionTypeEnum.ROWS_SET
}

type ActionCheckResultSet = {
	checkResult?: CsvImportReturnDto
	type: ActionTypeEnum.CHECK_RESULT_SET
}

type ActionInputDataParsedSet = {
	inputDataParsed?: InputDataParsed
	type: ActionTypeEnum.INPUT_DATA_PARSED_SET
}

type ActionHasHeadersSet = {
	hasHeaders: boolean
	type: ActionTypeEnum.HAS_HEADERS_SET
}

type ActionCsvMappingUpdate = {
	mapping: CsvMapping
	type: ActionTypeEnum.CSV_MAPPING_UPDATE
}

export type Actions =
	| ActionChangeStep
	| ActionFormDataCheckSet
	| ActionRowsSet
	| ActionCheckResultSet
	| ActionInputDataParsedSet
	| ActionHasHeadersSet
	| ActionCsvMappingUpdate
